export default __webpack_public_path__ + "static/media/kinto.ee826e32.svg";